'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationPaymentController = function () {
    function WinresReservationPaymentController($scope, $rootScope, reservationService, localizationService, $window, $timeout, $q, userService) {
        _classCallCheck(this, WinresReservationPaymentController);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.reservationService = reservationService;
        this.localizationService = localizationService;
        this.$window = $window;
        this.showPaymentError = false;
        this.$timeout = $timeout;
        this.$q = $q;
        this.userService = userService;
        this.destinationPrivacyPolicyLinks = [];
    }

    _createClass(WinresReservationPaymentController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.mode = this.modeParam || 'buttons';

            this.askPaymentOption = "true";
            this.useDynamicMethods = false;

            this.setPending();

            this.paying = false;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().AcceptTerms
            // getConfirmBookingResult()

            // Set:
            // setCurrentPhase()
            // setAmountToPay()

            // Other:
            // updatePaymentMethods()
            // toPayment()

            this.tag = '(Old)';

            if (this.context) {
                this.tag = '(New)';
                console.log('[WinresReservationPayment]', this.tag, 'This is the new one.');
                this.context.disableOtherPayment = true;
                this.winresReservationContext = this.context;
                this.showErrors = 'false';
                this.askPaymentOption = undefined;
            } else {
                console.log('[WinresReservationPayment]', this.tag, 'This is the old one.');
            }

            if (!this.context && this.winresReservationContext.disableOtherPayment) return;

            console.log('[WinresReservationPayment]', this.tag, 'Initializing.');

            this.data = this.winresReservationContext.getContext();

            //this.$scope.data = this.winresReservationContext.getContext();
            //this.$scope.$on("pay-button-click", ()=>{
            this.$scope.$on('updatePaymentMethods', function () {
                if (!_this.context && _this.winresReservationContext.disableOtherPayment) return;
                console.log('[WinresReservationPayment]', _this.tag, 'Updating payment methods.');
                _this.showPaymentError = false;
                _this.setPending();
                _this.winresReservationContext.updatePaymentMethods();
            });

            this.$scope.$on('paymentMethodsUpdated', function (event, methods) {
                if (!_this.context && _this.winresReservationContext.disableOtherPayment) return;
                var mode = _this.winresReservationContext.getWinresReservationPaymentMode();
                if (!_this.modeParam && mode) {
                    console.log('[Payment] Component mode is:', mode);
                    _this.mode = mode;
                }
                _this.useDynamicMethods = _this.mode === 'grid-buttons';
                _this.setReady(methods);
                _this.paymentMethods = methods;
                // console.log('[Payment] payment methods are:', this.paymentMethods);
                if (_this.askPaymentOption == "true") {
                    console.log('[WinresReservationPayment]', _this.tag, 'Getting payment options because this.askPaymentOption is', _this.askPaymentOption);
                    _this.getPaymentOptions();
                }
                _this.showPaymentError = methods == null;

                if (_.some(_this.paymentMethods, function (paymentMethod) {
                    return paymentMethod.InternalName === 'FREE';
                })) {
                    _this.hasZeroPricePaymentMethod = true;
                    _this.zeroPriceError = _this.data.totalPrice > 0;

                    if (_this.zeroPriceError) {
                        console.error('[Payment] Reservation total price > 0 with zero price payment method');
                    }
                }
            });

            // Needed to update payment methods when scope loads.
            this.winresReservationContext.updatePaymentMethods();

            // this.$scope.$on('paymentNoProducts', ()=>{
            //     this.showPaymentError = true;
            // });

            this.$scope.$on('confirmBooking', function () {
                _this.confirmBookingResult = _this.winresReservationContext.getConfirmBookingResult();
            });
            this.termsSwitch = this.termsSwitch;

            this.$scope.$watch('$ctrl.data.AcceptTerms', function (terms, prevterms) {
                if (!_this.context && _this.winresReservationContext.disableOtherPayment) return;
                // Is there any reason to do this, if we have the option to disable the buttons instead?
                // It seems there isn't.
                if (terms == false && _this.mode != 'grid-buttons') {
                    _this.winresReservationContext.setCurrentPhase(undefined); // hide accept terms and payment methods.
                }

                if (prevterms) _this.firstAcceptTermsChange = true;
                if (terms && !_this.firstAcceptTermsChange) {
                    _this.triggerFirstAcceptTermsChange();
                    _this.firstAcceptTermsChange = true;
                }
            });

            this.errorEvent = 'winresReservationShowPrebookErrors';
            this.$scope.$on('winresPrebookError', function (event, data) {
                if (!_this.context && _this.winresReservationContext.disableOtherPayment) return;
                var message = void 0;
                if (data === undefined) {
                    message = 'prebook.error_common';
                } else if (data.ClosingTimePast === true) {
                    message = 'prebook.error_closing_time_past';
                } else {
                    message = 'prebook.error_common';
                }

                _this.$rootScope.$broadcast(_this.errorEvent, [{
                    Message: message,
                    Params: {}
                }]);
            });

            // Use openLink binding for accept terms link if set,
            // If not set, get accept terms link from Winres.
            if (!this.openLink) {
                this.getWinresReservationAcceptTermsLink();
            }

            // Destination privacy policy.
            this.$scope.$watchCollection('$ctrl.data.Products', function () {
                return _this.getDestinationsPrivacyPolicies();
            }, true);
        }
    }, {
        key: 'setPending',
        value: function setPending() {
            this.loading = true; // Legacy
            this.deferred = this.$q.defer();
            this.promise = this.deferred.promise;
        }
    }, {
        key: 'setReady',
        value: function setReady(result) {
            this.loading = false; // Legacy
            if (this.deferred) {
                this.deferred.resolve(result);
            }
        }
    }, {
        key: 'triggerFirstAcceptTermsChange',
        value: function triggerFirstAcceptTermsChange() {
            // Google analytics.
            this.winresReservationContext.analyticsEvent("trackCheckout", 3);
        }
    }, {
        key: 'getPaymentOptions',
        value: function getPaymentOptions() {
            var _this2 = this;

            this.reservationService.GetPaymentOptions(this.data).then(function (options) {
                _this2.options = options;
                _this2.FinalPayment = _.find(_this2.options.Balance.ActiveInvoices, function (invoice) {
                    return invoice.Type === 'Final';
                });
                _this2.AdvancePayment = _.filter(_this2.options.Balance.ActiveInvoices, function (invoice) {
                    return invoice.Type === 'Advance';
                });

                // Set default payment choice to reservation
                // Note: Does not check radio button
                _this2.paymentOptionChoice = 'reservation';
                _this2.paymentOptionChange();

                // Force check radio buttons
                // TODO: use better method
                _this2.forceRadioButtons();

                //this.addDiscountPriceToUnpaid(options.Balance);
            });
        }
    }, {
        key: 'forceRadioButtons',
        value: function forceRadioButtons() {
            var radioButtons = this.paymentOptionChoice === 'reservation' ? document.getElementsByClassName('reservation-fee') : document.getElementsByClassName('full-price');

            _.each([].concat(_toConsumableArray(radioButtons)), function (radioButton) {
                return radioButton.checked = true;
            });
        }

        // addDiscountPriceToUnpaid(balance) {
        //     var discountPrice = 0;
        //     if (this.data.DiscountProducts) {
        //         _.each(this.data.DiscountProducts, productLine => {
        //             discountPrice += productLine.TotalPrice;
        //         });
        //     }

        //     balance.Unpaid += discountPrice;
        // }

    }, {
        key: 'paymentOptionChange',
        value: function paymentOptionChange(option) {
            // todo: make this to re-fetch payment methods to get payment-fee. (haven't been possible to test does it work)

            if (this.paymentOptionChoice == 'full') {
                this.winresReservationContext.setAmountToPay(this.options.Balance.Unpaid);
            } else if (this.paymentOptionChoice == 'reservation') {
                if (this.AdvancePayment.length > 0) {
                    this.winresReservationContext.setAmountToPay(this.AdvancePayment[0].UnpaidAmount);
                }
            } else {
                console.error("payment option not recognised");
            }

            this.forceRadioButtons();
        }

        // Called from winresReservationPaymentMethod (which are transcluded into
        // this component)

    }, {
        key: 'getPaymentMethod',
        value: function getPaymentMethod(internalName) {
            if (!this.paymentMethods) {
                return null; // Not yet loaded
            }
            return _.find(this.paymentMethods, function (method) {
                return method.InternalName == internalName;
            });
        }
    }, {
        key: 'payZeroPrice',
        value: function payZeroPrice() {
            if (this.data.AcceptTerms) {
                return this.toPayment('FREE');
            } else {
                alert(this.$filter('i18next')('reservation_customer.error_terms'));
                return undefined;
            }
        }
    }, {
        key: 'toPayment',
        value: function toPayment(internalName) {
            var _this3 = this;

            this.paying = true;
            var promise = this.winresReservationContext.toPayment(internalName);
            promise.then(function (success) {
                // Keep _paying_ true if we are currently redirecting the user to payment
                _this3.paying = !!success;
            }).catch(function (error) {
                // Something went wrong, so presumably we aren't currently redirecting the user.
                _this3.paying = false;
            });
            return promise;
        }
    }, {
        key: 'shouldShowAnything',
        value: function shouldShowAnything() {
            return this.data && this.data.AcceptPrivacyPolicy && (this.winresReservationContext.getCurrentPhase() == 'pay' || this.showAlways == 'true');
        }
    }, {
        key: 'shouldShowMethods',
        value: function shouldShowMethods() {
            return this.shouldShowAnything() && (this.data.AcceptTerms || this.mode == 'grid-buttons');
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled() {
            return !(this.data && this.data.AcceptTerms && !this.paying);
        }
    }, {
        key: 'alertTerms',
        value: function alertTerms() {
            alert(this.data.AcceptTerms);
        }
    }, {
        key: 'goToLink',
        value: function goToLink() {
            this.$window.open(this.openLink, '_blank');
        }
    }, {
        key: 'isPriceZero',
        value: function isPriceZero() {
            if (this.data.Products != null) {
                for (var i = 0; i < this.data.Products.length; i++) {
                    if (this.data.Products[i].TotalPrice != 0) {
                        return false;
                    }
                }
            }

            return true;
        }
    }, {
        key: 'getWinresReservationAcceptTermsLink',
        value: function getWinresReservationAcceptTermsLink() {
            var _this4 = this;

            this.$scope.$watch(function () {
                return _this4.userService.getCurrentUser();
            }, function () {
                // Get accept terms link from Winres.
                _this4.openLink = _this4.userService.getBookingConditions();
            });
        }
    }, {
        key: 'getDestinationsPrivacyPolicies',
        value: function getDestinationsPrivacyPolicies() {
            var _this5 = this;

            if (!this.context && this.winresReservationContext.disableOtherPayment) return;

            this.destinationPrivacyPolicyLinks = [];

            var language = this.localizationService.getLanguage();

            _.each(this.data.Products, function (productLine) {
                if (productLine.Product && productLine.Product.DestinationInfo) {
                    // Require product.
                    var destCode = productLine.Product.DestinationInfo.DestinationCode;
                    var destName = productLine.Product.DestinationInfo.DestinationName;
                    var prodName = productLine.Product.DestinationInfo.ProductName;

                    _this5.userService.getDestinationPrivacyPolicy(destCode, language).then(function (privacyPolicyLink) {
                        if (privacyPolicyLink) {
                            _this5.destinationPrivacyPolicyLinks.push({
                                'destCode': destCode,
                                'name': destName || prodName,
                                'href': privacyPolicyLink
                            });
                        }

                        // Unique privacy policy links by destination code.
                        _this5.destinationPrivacyPolicyLinks = _.uniqBy(_this5.destinationPrivacyPolicyLinks, 'destCode');

                        // Add commas if more than 1 privacy policy links.
                        if (_this5.destinationPrivacyPolicyLinks.length > 1) {
                            var i = 0;
                            for (i = 0; i < _this5.destinationPrivacyPolicyLinks.length - 1; i++) {
                                _this5.destinationPrivacyPolicyLinks[i].destName += ',';
                            }
                        }
                    });
                }
            });
        }
    }]);

    return WinresReservationPaymentController;
}();

WinresReservationPaymentController.$inject = ['$scope', '$rootScope', 'reservationService', 'localizationService', '$window', '$timeout', '$q', 'userService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'payment';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('payment', require('./winresReservationPayment.html'));
}]);

_module3.default.component('winresReservationPayment', {
    templateUrl: getTemplate,
    controller: WinresReservationPaymentController,
    bindings: {
        // Always show payment regardless which tab is open
        showAlways: '@',

        modeParam: '@mode', // 'radios', 'buttons', or 'grid-buttons'. Overrides IN/MTV/se.

        // asks the terms here, can be also found in winresReservationPayButton and winresReservationCustomerInfo
        termsSwitch: '@',

        // Accept terms link. ex. pdf file. Leave empty to open modal.
        openLink: '@',

        //changes the text when mode == 'buttons'
        buttonsText: '@',

        //asks if customer wants to pay only reservation fee or the whole payment
        askPaymentOption: '@',

        // message to booking. true to enable.
        showTermsMessage: '@',

        // Hide the <h2> element.
        hideHeading: '@',

        // Reference to <winres-reservation-context> if not available through below
        context: '<'
    },
    require: {
        winresReservationContext: '?^^winresReservationContext'
    },
    transclude: {
        'winresReservationPaymentMethods': 'winresReservationPaymentMethods'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationPayment/winresReservationPayment.js
// module id = 408
// module chunks = 2